import React from 'react';
import { IIssue } from 'common/module_interface/RiskManagement/issues/Issues.interface';
import { DescriptionPanel } from '../../../../DrawerPanels/DescriptionPanel/DescriptionPanel';

export const IssueDescriptionPanel: React.FC<{ issue: IIssue }> = ({ issue }) => {
    return <DescriptionPanel description={issue.description} />;
};
